import LandForm from '../project-info/land-form/land-form.vue'; // 耕地
import WoodsForm from '../project-info/woods-form/woods-form.vue'; // 林地
import WaterForm from '../project-info/water-form/water-form.vue'; // 水面
import SihuangForm from '../project-info/sihuang-form/sihuang-form.vue'; // 四荒
import HouseForm from '../project-info/house-form/house-form.vue';
import FacilityForm from '../project-info/facility-form/facility-form.vue'; // 设备设施
import CarForm from '../project-info/car-form/car-form.vue'; // 车辆
import OthForm from '../project-info/oth-form/oth-form.vue'; // 车辆
import equityForm from '../project-info/equity-form/equity-form.vue'; // 股权
import OtherForm from '../project-info/other-form/other-form.vue';
import synthesizeForm from '../project-info/synthesize-form/synthesize-form.vue'; // 综合类
import resourcesList from '../project-info/resources-list/index.vue'; // 综合类
import { mapGetters } from 'vuex';
import Service from '@/service/index.js';
import AssetsService from '../service.js';

export default {
  components: {
    LandForm,
    WoodsForm,
    OtherForm,
    WaterForm,
    SihuangForm,
    FacilityForm,
    HouseForm,
    synthesizeForm,
    resourcesList,
    CarForm,
    equityForm,
    OthForm
  },
  data () {
    return {
      asstesType: '',
      asstesTypeText: '',
      ruleForm: {
        type: '',
        assetsLargeType: '',
        projectType: '',
        projectSubType: '',
        assetsCode: ''
      },
      rules: {
        assetsLargeType: [
          { required: true, message: '请选择项目类型', trigger: 'change' }
        ],
        projectType: [
          { required: true, message: '请选择项目类型', trigger: 'change' }
        ],
        projectSubType: [
          { required: true, message: '请选择项目分类', trigger: 'change' }
        ],
        bidGeneralSituation: [
          { required: true, message: '请选择标的概况', trigger: 'change' }
        ]
      },
      assetsLargeTypeArr: [],
      projectTypeArr: [],
      projectSubTypeArr: {},
      bidGeneralSituationArr: [],
      test: null,
      projectInfo: {},
      landTotalForm: {}
      // assetsCode: ''
    };
  },
  computed: {
    ...mapGetters([
      'assetsCode'
    ])
  },
  watch: {
    // 标的情况
    'ruleForm.bidGeneralSituation': function (value) {
      Bus.$emit('bidGeneralSituationChange', value);
    }
  },
  created () {
    this.asstesType = this.$route.query.asstesType;
    this.ruleForm.type = this.$route.query.asstesType;
    // console.log(this.asstesType);
    if (this.asstesType === '0') {
      this.asstesTypeText = '资源性资产';
    }
    if (this.asstesType === '1') {
      this.asstesTypeText = '经营性资产';
    }
    if (this.asstesType === '2') {
      this.asstesTypeText = '非经营性资产';
    }
    // Service.getSelectList('PROJECT_TYPE').then(({ code, data }) => {
    //   if (code === '0') {
    //     this.projectTypeArr = data;
    //     this.projectSubTypeArr = this.projectTypeArr.find(item => item.code === this.ruleForm.projectType);
    //   }
    // });
    // 资产大类
    Service.getSelectList('ASSETS_LARGE_TYPE').then(({ code, data }) => {
      if (code === '0') {
        this.assetsLargeTypeArr=[];
        this.assetsLargeTypeArr = data;
        if (this.asstesType === '0') {
          this.ruleForm.assetsLargeType = '1';
          this.ruleForm.projectType = '1';
          this.ruleForm.projectSubType = '1';
          this.assetsLargeTypeArr = this.assetsLargeTypeArr.slice(0, 5);
        }
        if (this.asstesType === '1') {
          this.ruleForm.assetsLargeType = '6';
          this.assetsLargeTypeArr = this.assetsLargeTypeArr.slice(5, 6);
        }
        if (this.asstesType === '2') {
          this.ruleForm.assetsLargeType = '7';
          this.assetsLargeTypeArr = this.assetsLargeTypeArr.slice(6, 7);
        }
        this.projectTypeArr = this.assetsLargeTypeArr[0].list;
        this.projectSubTypeArr = this.projectTypeArr[0].list;

        // console.log(this.assetsLargeTypeArr);
      }
    });

    // Service.getSelectList('ASSETS_MASSIF_TYPE').then(({ code, data }) => {
    //   if (code === '0') {
    //     console.log(data);
    //   }
    // });
    this.getTimestamp();
  },

  methods: {
    getTimestamp () {
      if(this.$route.query.editorid) {
        AssetsService.batchgetUpdateBatchAllAssets(this.$route.query.editorid).then(({ code, data }) => {
          if (code === '0') {
            this.ruleForm.assetsCode = data[0].identification;
          }
        });
      }else {
        if (this.$route.query.identification) {
          this.ruleForm.assetsCode = this.$route.query.identification;
        } else {
          AssetsService.getTimestamp().then((res) => {
            if (res.code === '0') {
              this.ruleForm.assetsCode = res.data;
            }
          });
        }
      }
    },
    onLandTotalForm (event) {
      this.landTotalForm = event;
    },
    // 获取项目子类集合
    selectChanged (val) {
      console.log(val);
      this.ruleForm.projectType = '';
      this.ruleForm.projectSubType = '';
      this.assetsLargeTypeArr.forEach(item => {
        if (item.code === val) {
          // console.log(item);
          this.projectTypeArr = item.list;
        }
      });
    },
    selectChanged1 (val) {
      console.log(this.ruleForm.projectType);
      this.ruleForm.projectSubType = '';
      this.projectSubTypeArr = {};
      this.projectTypeArr.forEach(item => {
        if (item.code === val) {
          // console.log(item);
          this.projectSubTypeArr = item.list;
        }
      });
    },
    previousStep () {
      this.$router.back();
    },
    submit () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let formList = ['landForm', 'woodsForm', 'waterForm', 'sihuangForm', 'houseForm', 'facilityForm', 'synthesizeForm', 'carForm', 'equityForm', 'othForm'];
          formList.forEach(item => {
            if (this.$refs[item]?.test()) {
              this.test = this.$refs[item].test();
            }
          });
          this.test.then((res) => {
            console.log(res, 2222);
            let params = {
              ...res,
              ...this.ruleForm
            };
            params.assetsInfo = JSON.stringify(params.massifs);
            delete params.massifs;
            console.log(params, '====params');
            AssetsService.addBatchAssets(params).then(res => {
              if (res.code === '0') {
                this.$successMessage('资产添加成功');
                this.$refs.resourcesList.getList();
                let formList = ['landForm', 'woodsForm', 'waterForm', 'sihuangForm', 'houseForm', 'facilityForm', 'synthesizeForm', 'carForm', 'equityForm', 'othForm'];
                formList.forEach(item => {
                  if (this.$refs[item]?.test()) {
                    this.$refs[item].clear();
                  }
                });
              }
            }).catch(error => {
              console.log(error, '===error');
            });
          });
        }
      });
    }
  }
};
